<template src="../templates/normal_fcont_129.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import AppDownloadiPrint from '../components/AppDownloadiPrint';

import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,
    InfoMachineTranslation,AppDownloadiPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['129-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['129-2']}
    ]};
  }
  
};
</script>
<style >
</style>

